import { render, staticRenderFns } from "./c_pictrue.vue?vue&type=template&id=a1aed574&scoped=true"
import script from "./c_pictrue.vue?vue&type=script&lang=js"
export * from "./c_pictrue.vue?vue&type=script&lang=js"
import style0 from "./c_pictrue.vue?vue&type=style&index=0&id=a1aed574&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1aed574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1aed574')) {
      api.createRecord('a1aed574', component.options)
    } else {
      api.reload('a1aed574', component.options)
    }
    module.hot.accept("./c_pictrue.vue?vue&type=template&id=a1aed574&scoped=true", function () {
      api.rerender('a1aed574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_pictrue.vue"
export default component.exports